const {h, render, Component} = require('preact');
class Spinner extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
    	<div class="gig-spinner gig-spinner-brnd spinner"></div>
    )
  }
}
module.exports = Spinner
